 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const Property2RightGridContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" side="right" gridSize={3} carShow={9} />
    </>
  );
};

export default Property2RightGridContainer;
